import type { InstalledIntegrationManifest } from '@cli-types/integration-engine/integrations.js'
import { createInstallableManifestStore } from '@core-engine/installable/manifest-store.js'

export const integrationManifestStore =
  createInstallableManifestStore<InstalledIntegrationManifest>('integrations')
